import { ConditionalFormatting } from '../models';

export function createConditionalFormattingObject(formObject) {
	if (formObject && formObject.conditionalFormattingConfiguration) {
		const { conditionalFormattingConfiguration } = formObject;
		const { fontSize, fontStyle, methodName, value: limitValue } = conditionalFormattingConfiguration;
		const formatObject: ConditionalFormatting = {
			fontColor: '#fff',
			fontSize,
			fontStyle,
			methodName,
			value: limitValue,
		};
		return formatObject;
	}
	const defaultFormatObject: ConditionalFormatting = {
		fontColor: '#3d3d3d',
		fontSize: '14px',
		fontStyle: 'Mulish,sans-serif!important',
		methodName: null,
		value: null,
	};
	return defaultFormatObject;
}

export function checkIfFormatApplied(methodName, limitValue, rawValue) {
	switch (methodName) {
		case 'less-than':
			if (limitValue > rawValue) {
				return true;
			} else {
				return false;
			}

		case 'empty':
			return false;

		case 'less-than-equal':
			if (limitValue >= rawValue) {
				return true;
			} else {
				return false;
			}
		case 'equal':
			if (limitValue == rawValue) {
				return true;
			} else {
				return false;
			}
		case 'greater-than':
			if (limitValue < rawValue) {
				return true;
			} else {
				return false;
			}

		case 'greater-than-equal':
			if (limitValue <= rawValue) {
				return true;
			} else {
				return false;
			}
		default:
			return false;
	}
}

export function conditionStyleCreater(fo) {
	const { fontStyle, fontColor, fontSize, value, methodName } = createConditionalFormattingObject(fo);
	return function formatString(rawValue) {
		const isFormatRequired = checkIfFormatApplied(methodName, value, rawValue);
		if (isFormatRequired) {
			return `style="color:${fontColor}; font-size:${fontSize};"`;
		} else {
			return '';
		}
	};
}
